import axios from 'axios';
import router from '../router';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_AMF_URL, // Standard-URL für deine API
  timeout: 3000000, // Maximale Wartezeit (in Millisekunden)
  headers: {
    'Content-Type': 'application/json', // Standardmäßiger Content-Typ
    'Accept': 'application/json', // Erwartetes Format der Antwort
  },
});

// Interceptor hinzufügen
axiosInstance.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response-Interceptor hinzufügen
axiosInstance.interceptors.response.use(
  (response) => {
    // Prüfen, ob die Antwort einen Hinweis auf einen ungültigen Token enthält
    if (response.data && response.data === 'Token invalid') {
      // Token ist ungültig, handle das entsprechend
      localStorage.removeItem("jwt"); // Entferne den ungültigen Token
      router.push('/login'); // Weiterleitung zur Login-Seite
    }
    return response; // Gib die Antwort normal zurück, wenn alles in Ordnung ist
  },
  (error) => {
    // Handle andere Fehler wie bisher
    return Promise.reject(error);
  }
);

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/utils/axiosinstance.js